mmf_modules.define('utils/tracking',['require','exports','module','jquery','utils/ensure_dataLayer'],function (require, exports, module) {
  var $ = require('jquery');
  var dataLayer = require('utils/ensure_dataLayer');

  exports.forceClickTrack = function (category, event) {
    dataLayer.push({
      'event': 'classic event',
      'category': category,
      'action': event
    });
  };

  exports.Init = function () {
    $(document).on('click', '.clicktrack', function (e) {
      var $clicked = $(e.target);
      var category = $clicked.data('category') || 'clicktrack',
      event = $clicked.data('name') || $clicked.attr('id') || $clicked.attr('name') || 'undefined';
      exports.forceClickTrack(category, event);
    });
  };

});

